module.exports = __webpack_public_path__ + "static/media/saopaulo.3880289b.png";